export const WALKTHROUGH_STEPS = [
  {
    id: 'welcome',
    title: 'Welcome to Your Scheduler!',
    description:
      "Let's walk through setting up your scheduler. You have a 90-day free trial—subscribe anytime from Manage Subscription in the menu to continue after your trial.",
    path: '/scheduler-dashboard',
    position: 'center',
  },
  {
    id: 'categories',
    title: 'Service Categories',
    description:
      'Review the default "Hair Care" category. If you offer different types of services (nails, skin, massage, etc.), add them as separate categories. This makes it easier for clients to browse your offerings.',
    path: '/scheduler-categories',
    position: 'center',
  },
  {
    id: 'services',
    title: 'Set Up Your Services',
    description:
      'Review the template services. Edit prices, descriptions, images, and duration to match your offerings. Add new services as needed.',
    path: '/service',
    position: 'center',
  },
  {
    id: 'schedule',
    title: 'Set Your Working Hours',
    description:
      'Define your weekly schedule. Use "Copy to All Days" to save time. You can manually override when booking appointments, add planned time off for vacations, and set shifts (e.g., close for lunch).',
    path: '/manage-schedule',
    position: 'center',
  },
  {
    id: 'clients',
    title: 'Add Your Clients',
    description:
      "Add clients here or from the storefront—they'll sync automatically. You can also upload client lists. Email is currently required as the unique identifier for each client.",
    path: '/clients',
    position: 'center',
  },
  {
    id: 'book-appointment',
    title: 'Book an Appointment',
    description:
      'Book from a client record or here in the Appointments tab. Month, Week, and Day views all support double-clicking on a time slot to add an appointment, or use the "Add Appointment" button.',
    path: '/appointments',
    position: 'center',
  },
  {
    id: 'drag-drop',
    title: 'Drag & Drop Appointments',
    description:
      'Easily reschedule by dragging appointments. On Month view, drag to a different day. On Week and Day views, drag to a different time.',
    path: '/appointments',
    position: 'center',
  },
  {
    id: 'overlapping',
    title: 'Overlapping Bookings',
    description:
      "Have a color job that needs an hour under the dryer? Squeeze in another haircut! You can create overlapping bookings—it's YOUR schedule.",
    path: '/appointments',
    position: 'center',
  },
  {
    id: 'color-coding',
    title: 'Color Code Your Services',
    description:
      'Assign colors to your service types for a quick visual glance at how your day will unfold. Pick colors that make sense to you.',
    path: '/service',
    position: 'center',
  },
  {
    id: 'notifications',
    title: 'Automatic Notifications',
    description:
      'All appointments automatically send notifications on booking, changes, and cancellations. A reminder is sent to clients (default: 24 hours before). Adjust the timing on the Manage Schedule page.',
    path: '/manage-schedule',
    position: 'center',
  },
];

export const WALKTHROUGH_STORAGE_KEY = 'scheduler_walkthrough';

export const getWalkthroughState = () => {
  try {
    const stored = localStorage.getItem(WALKTHROUGH_STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch {
    // ignore
  }
  return {
    currentStep: 0,
    completed: false,
    dismissed: false,
    startedAt: null,
  };
};

export const saveWalkthroughState = (state) => {
  try {
    localStorage.setItem(WALKTHROUGH_STORAGE_KEY, JSON.stringify(state));
  } catch {
    // ignore
  }
};
